export function LineChartIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6002 7.20005V24.8001H26.4002V7.20005H5.6002ZM4.8002 4.80005C3.91654 4.80005 3.2002 5.51639 3.2002 6.40005V25.6C3.2002 26.4837 3.91654 27.2001 4.8002 27.2001H27.2002C28.0839 27.2001 28.8002 26.4837 28.8002 25.6V6.40005C28.8002 5.51639 28.0839 4.80005 27.2002 4.80005H4.8002Z"
        fill="currentColor"
      />
      <path
        d="M24.8002 13.2C24.8002 14.3046 23.9048 15.2 22.8002 15.2C21.6956 15.2 20.8002 14.3046 20.8002 13.2C20.8002 12.0955 21.6956 11.2 22.8002 11.2C23.9048 11.2 24.8002 12.0955 24.8002 13.2Z"
        fill="currentColor"
      />
      <path
        d="M19.4182 14.4365L15.6002 18.2545L12.4487 15.103C11.9801 14.6344 11.2203 14.6344 10.7517 15.103L6.75167 19.103C6.28304 19.5716 6.28304 20.3314 6.75167 20.8001C7.2203 21.2687 7.98009 21.2687 8.44872 20.8001L11.6002 17.6486L14.7517 20.8001C15.2203 21.2687 15.9801 21.2687 16.4487 20.8001L20.9562 16.2926C20.2521 15.8718 19.7037 15.2175 19.4182 14.4365Z"
        fill="currentColor"
      />
      <path
        d="M20.8058 13.0488L21.1517 12.703C21.6203 12.2344 22.3801 12.2344 22.8487 12.703C23.3174 13.1716 23.3174 13.9314 22.8487 14.4L22.1551 15.0937C21.367 14.8253 20.8002 14.0789 20.8002 13.2C20.8002 13.1492 20.8021 13.0988 20.8058 13.0488Z"
        fill="currentColor"
      />
    </svg>
  )
}
